import { Component, Injectable } from '@angular/core';
import { CodeSnippet } from '../code-snippets/code-snippet.interface';



@Component({
    selector: 'misc-functions',
    template: '',
    standalone: false
})
export class MiscFunctionExample implements CodeSnippet{

    text : string = $localize`:@@script-editor.code-example.misc-function:misc functions`;

    category: string = 'examples';

    data: any;

    part = false;

    insert(): string | Promise<string> {
        return `function main()

    -- use urlencode when special chars are needed in an Url (i.E. for a northbound API call)
    show(
        urlencode('[{"Tenants":"Tdeadbeef-dead-beef-dead-beefdeadbeef"}]')
    )

    -- use frmt when formatting is needed as string result (see show formatted)
    show(
        frmt("Number: {0,10:000}", 42)
    )

    -- use tojsonqry when formatting structured data as a url query string
    -- remember: when the only argument to a function is a table literal
    -- as a shorthand the brackets can be ommitted. a({}) is equilvalent to a{}
    show(
        tojsonqry {
            skip = 10,
            take = 10,
            parentId = {
                { Tenants = "T"..getplant().tenantId}
            }
        }
    )

    -- use tojson when converting structured data to json
    show(
        tojson {
            a = 123,
            b = "hallo",
            c = true,
            d = { 1, 2, 3 }
        }
    )

    -- use fromjson when converting json to structured lua data
    -- remember: multiline strings in lua are defined by [[ ]]
    local d = fromjson([[
        {
            "a": 234,
            "b": "welt",
            "c": false,
            "d": [3, 4, 5]
        }
    ]])
    show("A: {0}\\r\\nB: {1}\\r\\nC: {2}\\r\\nD: [ {3}, {4}, {5} ]",
        d.a,
        d.b,
        d.c,
        d.d[1], d.d[2], d.d[3]
    )


end`
    }
}